import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function RequirePro({ children }) {
    const { token, user } = useAuth();
    const loc = useLocation();

    // If not logged in → go to login
    if (!token) {
        return <Navigate to="/login" replace state={{ from: loc }} />;
    }

    // If logged in but not Pro → go to pricing
    const isPro =
        user?.subscription_tier === "pro" &&
        (user?.subscription_status === "active" || user?.subscription_status === "trialing");

    if (!isPro) {
        return <Navigate to="/pricing" replace state={{ from: loc, needsPro: true }} />;
    }

    return children;
}
